import { render, staticRenderFns } from "./productAdvantageBlock.vue?vue&type=template&id=679141b6&scoped=true&"
import script from "./productAdvantageBlock.vue?vue&type=script&lang=js&"
export * from "./productAdvantageBlock.vue?vue&type=script&lang=js&"
import style0 from "./productAdvantageBlock.vue?vue&type=style&index=0&id=679141b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679141b6",
  null
  
)

export default component.exports